import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useEffect, useState } from 'react';
import { DialogWrapper } from '../../presentation-components/display-elements-components/dialog-wrapper';

export const ConversionFactorCustomAddNewYearDialog: React.FC<{
  open: boolean;
  onClose: () => void;
  availableYears: string[];
  onSubmit: (conversionYear: string) => void;
}> = ({ open, onClose, availableYears, onSubmit }) => {
  const [year, setYear] = useState<string>('');

  useEffect(() => {
    if (open) {
      setYear(availableYears[0] ?? '');
    }
  }, [open, availableYears]);

  const handleSubmit = () => {
    if (!year) return;
    onSubmit(year);
  };

  return (
    <DialogWrapper
      open={open}
      onClose={onClose}
      title={'Add conversion year'}
      cancelHandler={onClose}
      submitHandler={handleSubmit}
      isSubmitting={false}
      disableSaveButton={!year || availableYears.length === 0}
    >
      <FormControl fullWidth sx={{ mt: 2 }}>
        <InputLabel id='year-select-label'>Year</InputLabel>
        <Select
          labelId='year-select-label'
          label='Year'
          value={year}
          onChange={(e) => setYear(String(e.target.value))}
        >
          {availableYears.map(y => (
            <MenuItem key={y} value={y}>{y}</MenuItem>
          ))}
        </Select>
      </FormControl>
    </DialogWrapper>
  );
}

